import { Directive, InjectionToken } from '@angular/core';

/**
 * Injection token that can be used to reference instances of `MatSuffix`. It serves as
 * alternative token to the actual `MatSuffix` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const MAT_SUFFIX = new InjectionToken<MatSuffixDirective>('MatSuffix');

/** Suffix to be placed at the end of the form field. */
@Directive({
  selector: '[appMatSuffix]',
  providers: [{ provide: MAT_SUFFIX, useExisting: MatSuffixDirective }],
})
export class MatSuffixDirective {}
